import { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import "./NavBar.css";

const Navbar = () => {
  const { logoutUser, user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const initials = user
    ? (user.first_name?.[0] || user.username?.[0] || "?").toUpperCase()
    : "";

  const goSettings = () => {
    setOpen(false);
    navigate(user?.role === "admin" ? "/admin" : "/dashboard", { state: { tab: "settings" } });
  };

  const doLogout = () => {
    setOpen(false);
    logoutUser();
  };

  return (
    <nav className="navBar">
      <ul>
        <li className="brand">
          <Link to="/">GC Receipts</Link>
        </li>

        <li className="nav-right">
          {user ? (
            <div className="nav-avatar-wrap" ref={menuRef}>
              <button
                className="nav-avatar-btn"
                onClick={() => setOpen(o => !o)}
                aria-haspopup="true"
                aria-expanded={open}
              >
                <span className="nav-avatar-circle">{initials}</span>
                <span className="nav-avatar-name">
                  {user.first_name || user.username}
                  {user.role === "admin" && <span className="role-badge">admin</span>}
                </span>
                <span className="nav-avatar-caret">▾</span>
              </button>

              {open && (
                <div className="nav-dropdown">
                  <button className="nav-dropdown-item" onClick={goSettings}>
                    Settings
                  </button>
                  <div className="nav-dropdown-divider" />
                  <button className="nav-dropdown-item nav-dropdown-logout" onClick={doLogout}>
                    Log out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
